/**
 * Set cookie
 * @param {string} name cookie name
 * @param {*} value cookie value
 * @param {number} expiry_days expires in days
 */
export const setCookie = function (name, value, expiry_days) {
  const d = new Date();
  d.setTime(d.getTime() + expiry_days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
  return getCookie(name);
};

/**
 * Get cookie by name
 * @param {string} name cookie name
 */
export const getCookie = function (name) {
  const cookie_name = name + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(cookie_name) === 0) {
      return c.substring(cookie_name.length, c.length);
    }
  }
  return false;
};

export function purgeCookies(arr) {
  for (let i = 0; i < arr.length; i++) {
    const rgxpCookie = new RegExp('^(.*;)?\\s*' + arr[i] + '\\s*=\\s*[^;]+(.*)?$');
    if (document.cookie.match(rgxpCookie)) {
      document.cookie = arr[i] + '=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/;';
      document.cookie = arr[i] + '=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/; domain=.' + location.hostname + ';';
      document.cookie =
        arr[i] +
        '=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/; domain=.' +
        location.hostname.split('.').slice(-2).join('.') +
        ';';
    }
  }
}
